import type { FeaturePageSeo } from "@/components/feature-template/seo";
import type { FAQItem } from "@/components/feature-template/types";

// Shared by page.tsx (JSON-LD) and the client page (visible FAQ) so both always match.

export const faqs: FAQItem[] = [
  {
    question: "How does AI Job Match decide which jobs fit me?",
    answer:
      "It compares each listing with your profile: skills, years of experience, preferred locations, work mode and salary expectations. When you sort by Recommended, the roles that fit best appear first.",
  },
  {
    question: "Which industries and roles are covered?",
    answer:
      "Listings span technology, finance, healthcare, marketing, sales, design, operations and more, from entry-level roles to leadership positions.",
  },
  {
    question: "How often are listings updated?",
    answer:
      "New listings are added every hour, and each job shows when it was posted so you can focus on recent openings.",
  },
  {
    question: "Can I get alerts for new matches?",
    answer:
      "Yes. Run a search and choose Send me jobs like these. New roles that match that search are emailed to you as they are posted.",
  },
  {
    question: "What is JobsGPT?",
    answer:
      "JobsGPT is a swipe view of your matches. It shows one job at a time with the key details; swipe right to apply or left to pass.",
  },
  {
    question: "Can I track jobs I find here?",
    answer:
      "Yes. Click Track on any listing to add it to JobTracker AI with the role, company and link filled in, or save it to review later.",
  },
  {
    question: "Is my personal data secure?",
    answer:
      "Your data is encrypted in transit and at rest, and it is used only to match you with jobs and power your own MindMyJob tools.",
  },
];

export const seo: FeaturePageSeo = {
  slug: "ai-job-match",
  name: "AI Job Match",
  title: "AI Job Match: Jobs Ranked by Fit | MindMyJob",
  description:
    "Find jobs that fit your skills, experience and preferences. AI Job Match ranks fresh listings, sends alerts for new matches and tracks jobs in one click.",
  keywords: [
    "ai job match",
    "ai job search",
    "job matching platform",
    "jobs that match my skills",
    "personalized job recommendations",
    "job alerts",
    "fresh job listings",
    "remote and hybrid jobs",
    "job search filters",
    "job board india",
  ],
  ogImage: "/assets/images/features/ai-job-match/hero-ranked-matches.png",
  ogImageAlt:
    "MindMyJob AI Job Match showing jobs ranked by match score with fresh posting badges",
  featureList: [
    "Jobs ranked by fit to your profile",
    "Filters for work mode, experience, department, salary and company type",
    "Posting date on every listing",
    "Email alerts for saved searches",
    "JobsGPT swipe-to-apply view",
    "One-click tracking in JobTracker AI",
  ],
  faqs,
};
